export const POST_REQUEST = 'login/POST_REQUEST'
export const POST_SUCCESS = 'login/POST_SUCCESS'
export const POST_FAILURE = 'login/POST_FAILURE'
export const GET_REQUEST = 'login/GET_REQUEST'
export const GET_SUCCESS = 'login/GET_SUCCESS'
export const GET_FAILURE = 'login/GET_FAILURE'

export const UPDATE_REDIRECT_TO = 'login/UPDATE_REDIRECT_TO'
export const UPDATE_TWO_FACTOR_AUTHENTICATION_ID = 'login/UPDATE_TWO_FACTOR_AUTHENTICATION_ID'
export const UPDATE_LOGIN_CHECK_NOTIFICATION = 'login/UPDATE_LOGIN_CHECK_NOTIFICATION'